import React, { useState } from 'react';
import { 
  ShieldAlert, Star, HeartHandshake, ArrowLeft, 
  Clock, CheckCircle2, Filter, Share2, 
  RotateCcw, CheckSquare, Square, MessageCircle, X
} from 'lucide-react';

// ✅ CONEXIÓN AL SISTEMA NERVIOSO CENTRAL (Ruta Absoluta)
import { useGlobal } from 'context/GlobalContext';

const CentroIncidencias = () => {
  // 1. Consumimos las alertas reales enviadas por los maestros
  const { alertasAdmin, setAlertasAdmin } = useGlobal();

  const [incidenciaActiva, setIncidenciaActiva] = useState(null);
  const [mensajeEdicion, setMensajeEdicion] = useState('');
  const [tutoresSeleccionados, setTutoresSeleccionados] = useState([]);
  const [filtroActivo, setFiltroActivo] = useState('todos');

  // --- MOTOR DE PSICOLOGÍA INFANTIL (RESTAURADO) ---
  const obtenerMensajePsicologico = (tipo, nombreNino) => {
    const nombre = nombreNino.split(' ')[0];
    const plantillas = {
      crecimiento: `¡Hola familia! 👋 Queremos contarles que hoy ${nombre} tuvo un momento de gran aprendizaje emocional. Notamos que le costó un poquito gestionar la espera o compartir, lo cual es normal en su etapa. Nos encantaría que en casa platiquen sobre la paciencia para que hagamos equipo por su corazón. ¡Los queremos! ❤️`,
      positivo: `¡Hola familia! ✨ Estamos muy felices porque hoy ${nombre} brilló especialmente. Mostró mucha empatía y colaboración en clase, reflejando los valores que ustedes le enseñan. ¡Gracias por permitirnos ser parte de su crecimiento! 🙌`,
      ATENCIÓN: `¡Hola familia! 🚨 ${nombre} nos necesita un momentito por aquí. Todo está bajo control, pero su presencia nos ayudaría a que se sienta más tranquilo(a). ¿Podría alguno acercarse al salón? 🙏`,
      CONDUCTA: `¡Hola familia! 👋 Notamos que ${nombre} hoy tiene mucha energía y le está costando un poquito seguir las instrucciones del grupo. Nada de qué preocuparse, pero nos ayudaría mucho si refuerzan el valor de la escucha en casa. ¡Hacemos equipo! 😊`
    };
    return plantillas[tipo] || `Hola familia, tenemos un aviso importante sobre ${nombre}.`;
  };

  // --- ACCIONES ---
  const abrirIncidencia = (alerta) => {
    setIncidenciaActiva(alerta);
    setMensajeEdicion(obtenerMensajePsicologico(alerta.tipo, alerta.nino));
    // Pre-seleccionar tutores disponibles
    const idsTutores = alerta.tutores?.map((t, i) => `t-${i}`) || ['t-0'];
    setTutoresSeleccionados(idsTutores);
  };

  const toggleTutor = (id) => {
    setTutoresSeleccionados(prev => 
      prev.includes(id) ? prev.filter(t => t !== id) : [...prev, id]
    );
  };

  const ejecutarDespachoTotal = () => {
    if(tutoresSeleccionados.length === 0) return alert("Selecciona al menos un tutor.");
    
    // Simulación de envío a Firebase Cloud Messaging
    alert(`✅ Sincronización Exitosa:\n1. Mensaje enviado a la App del Padre.\n2. Notificación Push disparada.`);
    
    // Quitamos la alerta de la bandeja del Admin para limpiar el flujo
    setAlertasAdmin(alertasAdmin.filter(a => a.id !== incidenciaActiva.id));
    setIncidenciaActiva(null);
  };

  const alertasFiltradas = filtroActivo === 'todos' ? alertasAdmin : alertasAdmin.filter(a => a.tipo === filtroActivo);

  return (
    <div className="w-full max-w-[1400px] mx-auto space-y-8 animate-in fade-in duration-500 pb-24 px-4 text-left font-sans">
      
      {!incidenciaActiva ? (
        <>
          {/* HEADER Y FILTROS */}
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 border-b-4 border-slate-100 pb-8">
            <div className="space-y-2">
              <div className="inline-flex items-center gap-2 bg-[#0A2440] text-white px-5 py-2 rounded-full mb-2 shadow-lg">
                <ShieldAlert size={18} className="text-amber-400" />
                <span className="text-[10px] font-black uppercase tracking-widest italic">Centro de Control Familiar</span>
              </div>
              <h2 className="text-4xl md:text-6xl font-black text-slate-900 italic tracking-tighter uppercase leading-none">Incidencias</h2>
            </div>

            <div className="flex bg-white p-2 rounded-[2rem] shadow-md border-2 border-slate-50 gap-2">
              {[
                { id: 'todos', label: 'Bandeja', icon: Filter },
                { id: 'CONDUCTA', label: 'Conducta', icon: ShieldAlert },
                { id: 'positivo', label: 'Honor', icon: Star }
              ].map(f => (
                <button
                  key={f.id}
                  onClick={() => setFiltroActivo(f.id)}
                  className={`flex items-center gap-2 px-6 py-3 rounded-full transition-all text-[10px] font-black uppercase tracking-widest ${
                    filtroActivo === f.id ? 'bg-slate-900 text-white shadow-md' : 'bg-slate-50 text-slate-400 hover:bg-slate-100'
                  }`}
                >
                  <f.icon size={14}/> {f.label}
                </button>
              ))}
            </div>
          </div>

          {/* GRID DE REPORTES */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {alertasFiltradas.length === 0 ? (
              <div className="col-span-full py-24 text-center space-y-4 bg-white rounded-[4rem] border-4 border-dashed border-slate-100 opacity-40">
                <CheckCircle2 size={80} className="mx-auto text-emerald-400" />
                <p className="text-xl font-black uppercase tracking-widest text-slate-400 italic">No hay reportes pendientes del Staff</p>
              </div>
            ) : (
              alertasFiltradas.map(alerta => (
                <div 
                  key={alerta.id} 
                  onClick={() => abrirIncidencia(alerta)}
                  className="bg-white p-8 rounded-[3.5rem] border-4 border-slate-50 cursor-pointer hover:border-indigo-500 transition-all shadow-sm hover:shadow-2xl relative overflow-hidden"
                >
                  <div className={`absolute top-0 right-0 w-24 h-24 rounded-bl-full opacity-10 ${
                    alerta.tipo === 'CONDUCTA' ? 'bg-rose-500' : 'bg-emerald-500'
                  }`} />
                  
                  <div className="flex justify-between items-start mb-6">
                    <div className={`w-14 h-14 rounded-2xl flex items-center justify-center shadow-inner ${
                      alerta.tipo === 'CONDUCTA' ? 'bg-rose-50 text-rose-500' : 'bg-emerald-50 text-emerald-500'
                    }`}>
                      {alerta.tipo === 'CONDUCTA' ? <ShieldAlert size={28} /> : <Star size={28} />}
                    </div>
                    <span className="text-[10px] font-black text-slate-400 flex items-center gap-1 bg-slate-50 px-3 py-1.5 rounded-full italic">
                      <Clock size={12} /> {alerta.hora}
                    </span>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="text-left">
                      <h3 className="text-2xl font-black italic text-slate-900 tracking-tighter uppercase leading-none">{alerta.nino}</h3>
                      <p className="text-[10px] font-black text-indigo-500 uppercase tracking-widest mt-2">{alerta.salon}</p>
                    </div>
                    <p className="text-sm font-bold text-slate-500 italic border-l-4 border-slate-100 pl-4 py-1 line-clamp-3 text-left">
                      "{alerta.reporteMaestro}"
                    </p>
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      ) : (
        /* VISTA DE DESPACHO DETALLADO */
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 animate-in slide-in-from-right-8 duration-500">
          
          <div className="lg:col-span-5 space-y-6">
            <button onClick={() => setIncidenciaActiva(null)} className="flex items-center gap-2 text-slate-400 font-black text-[10px] uppercase hover:text-indigo-600 transition-colors ml-4 italic">
              <ArrowLeft size={16} /> Volver a la bandeja
            </button>

            <div className="bg-slate-900 p-10 rounded-[4rem] text-white shadow-2xl space-y-8 relative overflow-hidden border-b-8 border-indigo-600">
              <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500 opacity-10 rounded-bl-full" />
              <div className="space-y-1 text-left">
                <span className="text-[10px] font-black uppercase text-indigo-400 tracking-widest italic">Reporte Directo del Salón</span>
                <h2 className="text-4xl font-black italic tracking-tighter uppercase leading-none">{incidenciaActiva.nino}</h2>
              </div>
              <div className="bg-white/5 p-8 rounded-[2.5rem] border border-white/10 italic text-lg leading-relaxed text-slate-300 text-left shadow-inner">
                "{incidenciaActiva.reporteMaestro}"
              </div>
            </div>

            <div className="space-y-4 text-left">
              <h3 className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-8 italic">Responsables a Notificar</h3>
              <div className="grid gap-3">
                {(incidenciaActiva.tutores || [{nombre: 'Papá Principal'}, {nombre: 'Mamá Principal'}]).map((tutor, i) => (
                  <button 
                    key={i}
                    onClick={() => toggleTutor(`t-${i}`)}
                    className={`p-6 rounded-[2.5rem] border-4 transition-all flex justify-between items-center ${
                      tutoresSeleccionados.includes(`t-${i}`) ? 'bg-white border-indigo-600 shadow-xl scale-[1.02]' : 'bg-white border-slate-50 opacity-60 grayscale'
                    }`}
                  >
                    <div className="flex items-center gap-4">
                      {tutoresSeleccionados.includes(`t-${i}`) ? <CheckSquare className="text-indigo-600" size={24}/> : <Square className="text-slate-200" size={24}/>}
                      <div className="text-left">
                        <p className="text-base font-black text-slate-800 leading-none uppercase italic">{tutor.nombre}</p>
                        <p className="text-[9px] font-bold text-slate-400 uppercase mt-1 tracking-widest">Identidad Verificada</p>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-8">
            <div className="bg-white p-10 rounded-[4.5rem] border-4 border-slate-50 shadow-sm space-y-8 relative">
              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-black text-slate-800 italic flex items-center gap-3 leading-none uppercase tracking-tighter text-left">
                  <MessageCircle size={28} className="text-indigo-600"/> Filtro de Amor y Sabiduría
                </h3>
                <button 
                  onClick={() => setMensajeEdicion(obtenerMensajePsicologico(incidenciaActiva.tipo, incidenciaActiva.nino))}
                  className="p-3 bg-slate-50 rounded-full text-slate-400 hover:text-indigo-600 transition-all flex items-center gap-2 text-[9px] font-black uppercase tracking-widest italic"
                >
                  <RotateCcw size={14}/> Resetear
                </button>
              </div>

              <textarea 
                value={mensajeEdicion}
                onChange={(e) => setMensajeEdicion(e.target.value)}
                className="w-full p-8 bg-slate-50 rounded-[3rem] border-none text-xl font-bold text-slate-700 leading-relaxed focus:ring-4 focus:ring-indigo-500/10 transition-all resize-none h-[420px] shadow-inner italic"
                placeholder="Redacta el mensaje con amor..."
              />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <button 
                  onClick={() => {alert("Mensaje guardado localmente."); setIncidenciaActiva(null)}}
                  className="py-6 bg-slate-100 text-slate-400 rounded-[2.5rem] font-black text-[10px] uppercase tracking-widest hover:bg-slate-200 transition-all italic"
                >
                  Solo Bitácora Interna
                </button>
                <button 
                  onClick={ejecutarDespachoTotal}
                  className="py-6 bg-slate-900 text-white rounded-[2.5rem] font-black text-[11px] uppercase tracking-[0.2em] shadow-2xl hover:bg-emerald-600 transition-all flex items-center justify-center gap-3 group active:scale-95"
                >
                  <Share2 size={20} className="group-hover:rotate-12 transition-transform text-emerald-400" /> 
                  Sincronizar con Familia
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CentroIncidencias;